import { History } from 'history';
import { parse, stringify } from 'query-string';

const setVariation = (varId: string, history?: History, isBot: boolean = false): void => {
  if (history) {
    const search = {
      ...parse(history.location.search),
      sku: varId,
    };
    // remove search parameters for bots
    if (isBot) {
      delete search.sku;
      delete search['nav-c'];
    }
    // replace history
    history.replace({
      ...history.location,
      hash: stringify({
        ...parse(history.location.hash),
        sku: varId,
      }),
      search: stringify(search),
    });
  }
};

export default setVariation;
